import styles from './style.module.scss';

export const FeedCardHeader = ({ title, state, city, id, slug }) => {
  return (
    <div className={styles.header}>
      <h3 className={styles.title}>
        <a href={`/acoes-disponiveis/${id}-${slug}`}>{title}</a>
      </h3>
      <p className={styles.location}>
        {state} / {city}
      </p>
    </div>
  );
};
